<template>
  <Breadcrumbs
      title="Item Price Approve"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Items', path: '/items' },
      { label: 'Item Price', path: '/item-price-history' },
      { label: 'Item Price Approve', path: '/item-price-approve' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <itemPriceApprove/>
    </div>
  </div>
</template>

<script>
import itemPriceApprove from './item_price_approve_form.vue'
export default {
  name: 'indexList',
  components: {
    itemPriceApprove,
  },
}
</script>
